import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@egovsolutions/angular-prevent-autofocus';
import { PreventAutofocusModule } from '@egovsolutions/angular-prevent-autofocus';

class DialogCloseButtonComponent {
    constructor(
    // Dependencies
    dialogRef) {
        this.dialogRef = dialogRef;
    }
    // Clicked
    clickHandler() {
        if (this.closeHandler)
            this.closeHandler(this.dialogReturns);
        else
            this.dialogRef.close(this.dialogReturns);
    }
}
DialogCloseButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonComponent, deps: [{ token: i1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
DialogCloseButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.2", type: DialogCloseButtonComponent, selector: "egov-dialog-close-button", inputs: { dialogReturns: "dialogReturns", closeHandler: "closeHandler" }, ngImport: i0, template: "<button mat-button title=\"Close dialog\" egovPreventAutofocus (click)=\"clickHandler()\">\n    <mat-icon>close</mat-icon>\n</button>\n", styles: [":host{position:absolute;right:0;top:0;z-index:10}:host .mat-button.mat-button.mat-button{min-width:0;margin:10px 10px 0 0;line-height:35px;padding:0;width:35px}:host .mat-button.mat-button.mat-button mat-icon{font-size:14px;color:#888}\n"], components: [{ type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i4.PreventAutofocusDirective, selector: "[egovPreventAutofocus]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'egov-dialog-close-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button mat-button title=\"Close dialog\" egovPreventAutofocus (click)=\"clickHandler()\">\n    <mat-icon>close</mat-icon>\n</button>\n", styles: [":host{position:absolute;right:0;top:0;z-index:10}:host .mat-button.mat-button.mat-button{min-width:0;margin:10px 10px 0 0;line-height:35px;padding:0;width:35px}:host .mat-button.mat-button.mat-button mat-icon{font-size:14px;color:#888}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }]; }, propDecorators: { dialogReturns: [{
                type: Input
            }], closeHandler: [{
                type: Input
            }] } });

class DialogCloseButtonModule {
}
DialogCloseButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DialogCloseButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonModule, declarations: [DialogCloseButtonComponent], imports: [MatButtonModule,
        MatIconModule,
        PreventAutofocusModule], exports: [DialogCloseButtonComponent] });
DialogCloseButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonModule, imports: [[
            MatButtonModule,
            MatIconModule,
            PreventAutofocusModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: DialogCloseButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DialogCloseButtonComponent],
                    imports: [
                        MatButtonModule,
                        MatIconModule,
                        PreventAutofocusModule
                    ],
                    exports: [DialogCloseButtonComponent]
                }]
        }] });

/*
 * Public API Surface of angular-dialog-close-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogCloseButtonComponent, DialogCloseButtonModule };
